/**
 * @desc 1px line
 */
export { rect1px } from '@byted/light-render/lib/utils/line1px';
export function pixelOptimize(v) {
    return Math.floor(v) + 0.5;
}
